export default __webpack_public_path__ + "static/media/emoji-ok.912f6358.svg";